import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { filename: String, previewUrl: String }

  async download(event) {
    event.preventDefault()

    const btn = event.currentTarget
    const originalHtml = btn.innerHTML
    btn.disabled = true
    btn.innerHTML = '<i class="fas fa-spinner fa-spin mr-1"></i> Cargando...'

    try {
      // Fetch preview content from server
      const response = await fetch(this.previewUrlValue, {
        headers: { 'Accept': 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
      })
      if (!response.ok) throw new Error('Error al cargar contenido')
      const html = await response.text()

      // Show in preview modal
      this.setupModal()
      const previewBody = document.getElementById('menuDownloadPreviewContent')
      previewBody.innerHTML = html
      this.currentFilename = this.filenameValue || 'menu.pdf'

      const modal = document.getElementById('menuDownloadPreviewModal')
      $(modal).modal('show')
    } catch (error) {
      console.error('Error loading preview:', error)
      alert('Error al cargar la vista previa. Por favor intente nuevamente.')
    } finally {
      btn.disabled = false
      btn.innerHTML = originalHtml
    }
  }

  setupModal() {
    if (document.getElementById('menuDownloadPreviewModal')) return

    const modalHtml = `
      <div class="modal fade" id="menuDownloadPreviewModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-xl" role="document" style="max-width: 95%; margin: 20px auto;">
          <div class="modal-content" style="border: none; border-radius: 12px; overflow: hidden;">
            <div class="modal-body p-0" id="menuDownloadPreviewContent" style="max-height: 85vh; overflow-y: auto;">
            </div>
            <div class="modal-footer" style="background: #f8f9fa; border-top: 1px solid #e9ecef; padding: 12px 25px;">
              <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">
                <i class="fas fa-times mr-1"></i> Cerrar
              </button>
              <button type="button" class="btn btn-success" id="menuDownloadPdfBtn" style="background: linear-gradient(135deg, #33A036 0%, #28a745 100%); border: none;">
                <i class="fas fa-file-pdf mr-1"></i> Descargar PDF
              </button>
            </div>
          </div>
        </div>
      </div>
    `
    document.body.insertAdjacentHTML('beforeend', modalHtml)

    document.getElementById('menuDownloadPdfBtn').addEventListener('click', () => this.downloadFromPreview())
  }

  async downloadFromPreview() {
    const content = document.getElementById('menuDownloadPreviewContent')
    if (!content) return

    const downloadBtn = document.getElementById('menuDownloadPdfBtn')
    if (downloadBtn) {
      downloadBtn.disabled = true
      downloadBtn.innerHTML = '<i class="fas fa-spinner fa-spin mr-1"></i> Generando PDF...'
    }

    if (!window.html2pdf) {
      await this.loadScript('https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js')
    }

    // Remove scroll restrictions to capture full content
    const originalStyle = content.style.cssText
    content.style.maxHeight = 'none'
    content.style.overflow = 'visible'
    content.style.height = 'auto'

    await new Promise(resolve => setTimeout(resolve, 100))

    await this.convertFilteredImages(content)

    const contentHeight = content.scrollHeight
    const contentWidth = content.scrollWidth

    const opt = {
      margin: 0,
      filename: this.currentFilename || 'menu.pdf',
      image: { type: 'png', quality: 1 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        letterRendering: true,
        scrollX: 0,
        scrollY: 0,
        height: contentHeight,
        windowHeight: contentHeight
      },
      jsPDF: {
        unit: 'px',
        format: [contentWidth, contentHeight],
        orientation: 'landscape',
        hotfixes: ['px_scaling']
      }
    }

    try {
      await html2pdf().set(opt).from(content).save()
    } catch (error) {
      console.error('Error generating PDF:', error)
      alert('Error al generar el PDF. Por favor intente nuevamente.')
    } finally {
      content.style.cssText = originalStyle

      if (downloadBtn) {
        downloadBtn.disabled = false
        downloadBtn.innerHTML = '<i class="fas fa-file-pdf mr-1"></i> Descargar PDF'
      }
    }
  }

  loadScript(src) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = src
      script.onload = resolve
      script.onerror = reject
      document.head.appendChild(script)
    })
  }

  async convertFilteredImages(container) {
    const images = container.querySelectorAll('img[style*="filter"]')
    for (const img of images) {
      if (img.style.filter && img.style.filter.includes('invert')) {
        try {
          const whiteDataUrl = await this.createWhiteImage(img.src)
          img.src = whiteDataUrl
          img.style.filter = 'none'
        } catch (e) {
          console.warn('Could not convert image:', e)
        }
      }
    }
  }

  createWhiteImage(src) {
    return new Promise((resolve, reject) => {
      const img = new Image()
      img.crossOrigin = 'anonymous'
      img.onload = () => {
        const canvas = document.createElement('canvas')
        canvas.width = img.width
        canvas.height = img.height
        const ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0)
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
        const data = imageData.data
        for (let i = 0; i < data.length; i += 4) {
          if (data[i + 3] > 0) {
            data[i] = 255
            data[i + 1] = 255
            data[i + 2] = 255
          }
        }
        ctx.putImageData(imageData, 0, 0)
        resolve(canvas.toDataURL('image/png'))
      }
      img.onerror = reject
      img.src = src
    })
  }
}
